<template>
<div class="ee-progress" :style="`width: ${width}px;`">
  <div v-if="value > 0" class="ee-progress__bar" :style="`width: ${value}%`">{{value}}%</div>
</div>
</template>
<script>
  export default {
    compName: 'ee-progress-bar',
    props: {
      width: Number,
      value: {
        type: Number
      }
    }
  }
</script>
<style>
@component-namespace ee {
  @b progress {
    height: 20px;
    background-color: #ddd;
    border-radius: 10px;
    overflow: hidden;
    @e bar {
      height: 20px;
      text-align: right;
      background-color: #f99c40;
      border-radius: 10px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/packages/progess/ProgressBar.vue?c9d0bb62